import { createRouter, createWebHistory } from "vue-router";
import ToolPage from "@/views/ToolPage.vue";
import { setRedirectedInfo } from "@/helpers/redirectStorage";
import i18n from "@/i18n";

const t = i18n.global.t;
const privacyPolicy = () => import("../views/privacyPolicy.vue");
const termsOfService = () => import("../views/termsOfService.vue");
const cookiesPolicy = () => import("../views/cookiesPolicy.vue");
const usageGuidelines = () => import("../views/usageGuidelines.vue");
const routes = [
    {
        path: "/",
        name: "toolPage",
        meta: {
            title: t("viemao_downloader_page_title"),
            content: {
                description: t("viemao_downloader_page_description"),
            },
        },
        component: ToolPage,
    },
    {
        path: "/shorts/:id",
        name: "ShortsRedirect",
        meta: {
            title: t("viemao_downloader_page_title"),
            content: {
                description: t("viemao_downloader_page_description"),
            },
        },
        beforeEnter: (to, from, next) => {
            const needRedirect = handleRedirectIfNeeded(to);
            if (needRedirect) return;
            setRedirectedInfo(to.fullPath);
            next({ name: "toolPage" });
        },
    },
    {
        path: "/terms-of-service",
        name: "terms-of-service",
        component: termsOfService,
    },
    {
        path: "/privacy-policy",
        name: "privacy-policy",
        component: privacyPolicy,
    },
    {
        path: "/cookies-policy",
        name: "cookies-policy",
        component: cookiesPolicy,
    },
    {
        path: "/usage-guidelines",
        name: "usage-guidelines",
        component: usageGuidelines,
    },
    {
        path: "/watch",
        name: "WatchRedirect",
        meta: {
            title: t("viemao_downloader_page_title"),
            content: {
                description: t("viemao_downloader_page_description"),
            },
        },
        beforeEnter: (to, from, next) => {
            const needRedirect = handleRedirectIfNeeded(to);
            if (needRedirect) return;
            setRedirectedInfo(to.fullPath);
            next({ name: "toolPage" });
        },
    },
];

function handleRedirectIfNeeded(to) {
    const currentHost = window.location.hostname;
    const isDev = process.env.VUE_APP_BUILD_ENVIRONMENT !== "prod";
    const allowedDomain = "viemao.com";

    if (!isDev && currentHost !== allowedDomain) {
        const fullPath = to.fullPath;

        const targetUrl = `https://${allowedDomain}${fullPath}`;

        window.location.href = targetUrl;
        return true;
    }
    return false;
}

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.meta.content) {
        if (to.meta.content.keywords) {
            document.querySelector('meta[name="keywords"]')?.setAttribute("content", to.meta.content.keywords);
        }
        document.querySelector('meta[name="description"]')?.setAttribute("content", to.meta.content.description);
    }
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});
export default router;
